import BackButtonToolbar from "features/BackButtonToolbar";
import { ResourceContextProvider, SimpleForm, Title, useNotify, useRedirect, useRefresh } from "react-admin";
import { useLocation, useParams } from "react-router-dom";
import { CURRICULUMS, MODULES, StudentServicePath } from "utils/constants";
import EditForm from "./EditForm";
import dataProvider from "server/dataProvider";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";

const EditModule = () => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const location = useLocation();
  const module = location.state?.module;
  const curriculumName = location.state?.curriculumName;

  const { id } = useParams();

  const handleSubmit = async data => {
    const payload = {
      nameBg: data.nameBg,
      nameEn: data.nameEn,
    };

    try {
      await dataProvider.customRequest(studentRequests.updateCurriculumModule(id, module.id), payload, "PUT");

      notify("Успешно редактиране на модул за учебен план", { type: "success" });
      refresh();
      redirect(-1);
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <>
      <Title title={`Редакция модул за учебен план: ${curriculumName}`} />
      <BackButtonToolbar />
      <ResourceContextProvider value={`${StudentServicePath}${MODULES}/${CURRICULUMS}/${id}/edit`}>
        <SimpleForm
          defaultValues={{ nameBg: module?.nameBg, nameEn: module?.nameEn }}
          onSubmit={handleSubmit}
        >
          <EditForm />
        </SimpleForm>
      </ResourceContextProvider>
      <ConflictErrorDialog />
    </>
  );
};

export default EditModule;
